import { render, staticRenderFns } from "./InviteUsers.vue?vue&type=template&id=595604c4&scoped=true&"
import script from "./InviteUsers.vue?vue&type=script&lang=js&"
export * from "./InviteUsers.vue?vue&type=script&lang=js&"
import style0 from "./InviteUsers.vue?vue&type=style&index=0&id=595604c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595604c4",
  null
  
)

export default component.exports